import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

const NewPricelistCreatedModal = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation("pricelist-created");

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: 4,
          maxWidth: "500px",
          width: "100%",
        },
      }}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: "24px",
          py: "16px",
          borderBottom: "1px solid rgba(234, 234, 234, 1)",
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            color: "rgba(47, 43, 61, 0.9)",
            fontSize: "18px",
            p: 0,
            m: 0,
          }}
        >
          {t("title")}
        </DialogTitle>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" sx={{ color: "#666" }} />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: "24px", pt: "18px", textAlign: "center" }}>
        <Box sx={{ mb: "8px", width: "80px", height: "80px", mx: "auto" }}>
          <img
            src="/images/clapping-img.png"
            alt="clapping-img"
            width="100%"
            height="100%"
          />
        </Box>

        <Typography
          variant="h5"
          sx={{
            mb: "8px",
            fontSize: "18px",
            fontWeight: 600,
            color: "rgba(62, 63, 76, 1)",
            lineHeight: "28px",
          }}
        >
          {t("heading")}
        </Typography>

        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 400,
            color: "rgba(47, 43, 61, 0.9)",
            mb: "14px",
            lineHeight: "24px",
          }}
        >
          {t("paragraph")}
        </Typography>

        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            color: "rgba(62, 63, 76, 1)",
          }}
        >
          {t("finalNote")}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{ px: "24px", py: "12px", justifyContent: "flex-end" }}
      >
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            backgroundColor: "rgba(37, 124, 109, 1)",
            color: "white",
            borderRadius: "8px",
            textTransform: "none",
            fontSize: "15px",
            fontWeight: 500,
            px: "24px",
            py: "8px",
            boxShadow: "none !important",
            "&:hover": {
              backgroundColor: "rgba(30, 109, 91, 1)",
              boxShadow: "none",
            },
          }}
        >
          {t("button")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewPricelistCreatedModal;
